import type { IVoteOptimizationStrategy, VoteAllocation, VoteOptimizationInput } from "../vote-optimization-strategy"
import { calculateOptimalDistribution } from "../vote-optimization"
import { STRATEGY_ICON } from "../vote-optimization-strategy-factory"

/**
 * Degen strategy: Concentrates votes in 1-2 pools for potential degen earnings
 * Warning: Higher risk of vote dilution
 */
export class DegenVoteOptimizationStrategy implements IVoteOptimizationStrategy {
  calculateDistribution(input: VoteOptimizationInput): Array<VoteAllocation> | null {
    const distribution = calculateOptimalDistribution(input.gaugeBribes, input.selectedVotePower, true)
    return distribution
  }

  getName(): string {
    return "Degen"
  }

  getDescription(): string {
    return "Concentrates votes in 1-2 pools for potential degen earnings. Warning: Higher risk of vote dilution."
  }

  getIcon() {
    return STRATEGY_ICON.FLAME
  }
}
